const en = {
  inDevTxt: 'In Development',
  doneTxt: 'Done',
};

export default en;
